(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["whatsapp-widget"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const widgetSelector = '#wdb-whatsapp-widget';
    const closeTimers = new WeakMap();

    const getWidget = () => document.querySelector(widgetSelector);

    const openPanel = (widget = getWidget()) => {
      if (!widget) return;
      const panel = widget.querySelector('.wdb-panel');
      const toggle = widget.querySelector('.wdb-toggle');
      if (!panel || !toggle) return;

      window.clearTimeout(closeTimers.get(widget));
      panel.hidden = false;
      window.requestAnimationFrame(() => {
        widget.classList.add('is-open');
        panel.classList.add('is-visible');
        toggle.setAttribute('aria-expanded', 'true');
      });
    };

    const closePanel = (widget = getWidget(), returnFocus = false) => {
      if (!widget) return;
      const panel = widget.querySelector('.wdb-panel');
      const toggle = widget.querySelector('.wdb-toggle');
      if (!panel || !toggle) return;

      widget.classList.remove('is-open');
      panel.classList.remove('is-visible');
      toggle.setAttribute('aria-expanded', 'false');
      window.clearTimeout(closeTimers.get(widget));
      closeTimers.set(widget, window.setTimeout(() => {
        if (!widget.classList.contains('is-open')) panel.hidden = true;
      }, 260));
      if (returnFocus) toggle.focus();
    };

    window.WDB = window.WDB || {};
    window.WDB.openChat = () => openPanel();
    window.WDB.closeChat = () => closePanel();

    if (window.indartxuWhatsappWidgetBound) return;
    window.indartxuWhatsappWidgetBound = true;

    document.addEventListener('click', (event) => {
      const widget = getWidget();
      if (!widget) return;

      if (event.target.closest('.wdb-open-chat') && !event.target.closest(widgetSelector)) {
        event.preventDefault();
        openPanel(widget);
        return;
      }

      if (event.target.closest(`${widgetSelector} .wdb-toggle`)) {
        if (widget.classList.contains('is-open')) closePanel(widget);
        else openPanel(widget);
        return;
      }

      if (event.target.closest(`${widgetSelector} .wdb-close`)) {
        closePanel(widget, true);
        return;
      }

      if (widget.classList.contains('is-open') && !widget.contains(event.target)) {
        closePanel(widget);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const widget = getWidget();
      if (widget?.classList.contains('is-open')) closePanel(widget, true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
